var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"ChallengesHeader"}},[_c('div',{staticClass:"lineAcross"}),_c('div',{staticClass:"title",style:({fontSize: _vm.fontSize +'rem'})},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"lineAcross"})])}
var staticRenderFns = []

export { render, staticRenderFns }